import React, { useEffect } from 'react';
import styles from './Ticket.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getTicket, clearTicket, setTicketScanned } from '../../../../../store/actions/tickets';
import ContentSpinner from '../../../Spinner/Spinner';
import ModalHeading from '../../Heading/Heading';
import ModalCloseButton from '../../CloseButton/CloseButton';
import TicketInfo from './TicketInfo/TicketInfo';
import { renderTicketStatusName } from '../../../../../utils/render';
import { getTranslation } from '../../../../../utils/translation';

const TicketResult = props => {
    const dispatch = useDispatch();
    const { ticket, loadingTicket, errors } = useSelector(state => state.tickets);

    useEffect(() => {
        dispatch(getTicket(props.ticketCode));

        if (props.resetBarcodeKeyboard) {
            props.resetBarcodeKeyboard();
        }

        return () => {
            dispatch(setTicketScanned(false));
            dispatch(clearTicket());
        };
    }, []);

    return (
        <>
            {errors.length > 0 &&
                errors.map(error => <div className={styles.ticketError}>{error.description}</div>)}
            {loadingTicket ? (
                <div className={styles.loading}>
                    <ContentSpinner />
                </div>
            ) : (
                ticket && (
                    <>
                        <ModalHeading
                            statusId={ticket.status}
                            primary={renderTicketStatusName(ticket.status)}
                            secondary={`${getTranslation('ticketInformationHeaderBetType')} 
                                        ${ticket.ticketType}
                                        ${
                                            ticket.ticketType === 'SYSTEM'
                                                ? ticket.systemValues.trim().split(' ').join(', ')
                                                : ''
                                        }
                                            `}
                        >
                            <ModalCloseButton light onClick={() => props.closeModal()} />
                        </ModalHeading>
                        <TicketInfo ticket={ticket} />
                    </>
                )
            )}
        </>
    );
};

export default TicketResult;
